import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { selectIsAdmin, selectIsOperator } from "@/store/userSlice";
import { selectImpersonation } from "@/store/adminSlice";

const AdminGuard = ({ children }: { children: React.ReactNode }) => {
  const isAdmin = useSelector(selectIsAdmin);
  const isOperator = useSelector(selectIsOperator);
  const impersonation = useSelector(selectImpersonation);

  if (!isAdmin && !isOperator) {
    if (impersonation?.isImpersonating) {
      return <Navigate to="/dashboard" replace />;
    }

    return <Navigate to="/no-access" replace />;
  }

  return children;
};

export default AdminGuard;